import React, {useState} from "react";
import InputText from "../form-elements/input-text";

const GetUpdates = (
  {
    className = "",
    layout = "full",
    preTitle = "Get The",
    title = "Updates",
    description = "To say updated on the project process and all the latest stories subscribe to our mailing list.",
  }) => {
  const isLayoutFull = layout === 'full';
  const [isInputMessageActive, setInputMessageState] = useState(false);

  const handleInputFocus = () => {
    setInputMessageState(true);
  }

  const handleInputBlur = () => {
    setInputMessageState(false);
  }

  const handleEmailSubmit = () => {}

  return (
    <section className={`get-updates get-updates--${layout} ${className}`}>
      <div className="container">
        <div className="row align-items-center">
          <div className={`col-12 ${isLayoutFull ? 'col-lg-6' : ''}`}>
            <div className="get-updates__dropdown-title-wrapper">
              <div className="get-updates__dropdown-pre-title">{preTitle}</div>
              <div className="get-updates__dropdown-title">{title}</div>
            </div>
          </div>
          <div className={`col-12 ${isLayoutFull ? 'col-lg-5 offset-lg-1' : ''}`}>
            <div className="get-updates__dropdown-body-wrapper">
              <p className="get-updates__dropdown-body">{description}</p>
            </div>
            <div className="get-updates__dropdown-get-updates-wrapper">
              <div className="input-group">
                <div className="input-group__input-wrapper">
                  <InputText
                    className="input-group__input input-group__input--tall input-group__input--dark"
                    placeholder="Enter email for updates"
                    ariaLabel="Email"
                    onFocus={handleInputFocus}
                    onBlur={handleInputBlur}
                  />
                </div>
              </div>
              <div className="get-updates__dropdown-submit-wrapper">
                <button
                  type="submit"
                  className="button button--secondary button--tall"
                  onClick={handleEmailSubmit}>
                  Submit
                </button>
                <div className="get-updates__dropdown-privacy-wrapper">
                  <p className="get-updates__dropdown-privacy">Clicking submit you agree to evo’s <a href="https://www.evo.com/what-is-your-privacy-policy" target="_blank">privacy policy</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default GetUpdates
